<template>
  <div :style="{ opacity: loaded ? 1 : 0 }">
    <canvas
      ref="allStones"
      id="allStones"
    />
  </div>
</template>

<script type="text/javascript">
import {
  Scene,
  PerspectiveCamera,
  DirectionalLight,
  Fog,
  // AxesHelper,
  WebGLRenderer,
  // MeshPhongMaterial,
  TextureLoader,
  // Mesh
} from 'three'

import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'

export default {
  name: 'AllModelledScenes',
  props: {
    modelPath: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      cancelled: false,
      loaded: false,
      models: [
        // 'scene-1.gltf',
        'scene-2.gltf',
        'scene-3.gltf',
        'scene-4.gltf',
        'scene-5.gltf'
      ],
      renderer: null,
      sceneConfigurations: [],
      mouse: { x: 0, y: 0 }
    }
  },
  methods: {
    // 
    // MOUSE POSITION
    // 
    onMouseMove (e) {
      const x = e.clientX / window.innerWidth
      const y = e.clientY / window.innerHeight

      this.mouse = {
        x, y
      }
    },
    // 
    // GATHER CANVASES. LOOKS FOR ALL OF THEM IN THE SCENE
    // 
    gatherCanvases () {
      const elements = document.querySelectorAll('.modell')

      if (elements.length === 0) {
        this.cancelled = true
      } else {
        for (let el of elements) {
          let info = {
            uid: el.dataset.uid,
            src: el.dataset.src,
            el
          }

          this.sceneConfigurations.push(info)
        }
      }
    },
    // 
    // MAKE A TEMPLATE SCENE
    // 
    makeScene (config) {
      const scene = new Scene()
      const camera = new PerspectiveCamera(75, 400 / 400, 0.1, 1000)
      const light = new DirectionalLight(0xffffff, 0.2)
      const light2 = new DirectionalLight(0xffffff, 0.2)
      const light3 = new DirectionalLight(0xffffff, 0.7)

      light.position.set(-2, 1, 3)
      light2.position.set(2, 1, 3)
      light3.position.set(0, 0, 3)

      // const helper = new AxesHelper(2)

      camera.position.z = 2
      scene.add(light)
      scene.add(light2)
      scene.add(light3)

      scene.fog = new Fog(0xffffff, 1.2, 2)
      // scene.add(helper)

      return { scene, camera, config }
    },
    // 
    // SETUP A SPECIFIC SCENE
    // 
    setupScene (config) {
      const sceneInfo = this.makeScene(config)
      const model = this.models[Math.floor(Math.random() * this.models.length)]

      // const material = new MeshPhongMaterial({
      //   color: 0xffffff,
      //   emissive: 0xf0f0f,
      //   specular: 0x000000,
      //   shininess: 10,
      //   // map: texture
      // })

      sceneInfo.scene.name = config.uid
      const clone = model.scene.clone(true)
      sceneInfo.scene.add(clone)

      const texture = new TextureLoader().load(config.src)
      texture.flipY = false // for gltf weird mirroring

      const currentModel = this.getModel(sceneInfo.scene)

      config.initialRotation = { ...currentModel.rotation }
      currentModel.traverse(child => {
        if (child.material) {
          // const thisTexture = texture.clone()

          child.material = child.material.clone()
          child.material.map = texture
        }
      })

      return sceneInfo
    },
    // 
    // MAKE ALL SCENES
    // 
    makeScenes () {
      this.sceneConfigurations = this.sceneConfigurations.map((config) => {
        const sceneInfo = this.setupScene(config)
        return sceneInfo
      })
    },
    // 
    // 
    // 
    resizeRendererToDisplaySize () {
      const canvas = this.renderer.domElement
      const width = canvas.clientWidth
      const height = canvas.clientHeight
      const needResize = canvas.width !== width || canvas.height !== height
      if (needResize) {
        this.renderer.setSize(width, height, false)
      }
      return needResize
    },
    // 
    // 
    // 
    getModel (scene) {
      return scene.children.find(s => s.name === "Scene")
        .children.find(c => c.type === "Mesh")
    },
    // 
    // Only render the visible portions of the shit
    // 
    renderScene (sceneInfo) {
      const {
        scene,
        camera,
        config
      } = sceneInfo

      const {
        x,
        y,
        left,
        right,
        top,
        bottom,
        width,
        height
      } = config.el.getBoundingClientRect()

      const position = {
        x: (x + width / 2) / window.innerWidth,
        y: (y + height / 2) / window.innerHeight
      }

      const difference = {
        x: this.mouse.x - position.x,
        y: this.mouse.y - position.y
      }

      const factor = 0.4

      const shape = this.getModel(scene)

      shape.rotation.z = config.initialRotation._y + -(difference.x * factor)
      shape.rotation.x = config.initialRotation._x + difference.y * factor

      const isOffscreen =
        bottom < 0 ||
        top > this.renderer.domElement.clientHeight ||
        right < 0 ||
        left > this.renderer.domElement.clientW

      if (isOffscreen) return

      this.loaded = true

      camera.aspect = width / height
      camera.updateProjectionMatrix()

      const positiveYUpBottom = this.renderer.domElement.clientHeight - bottom

      this.renderer.setScissor(left, positiveYUpBottom, width, height)
      this.renderer.setViewport(left, positiveYUpBottom, width, height)

      this.renderer.render(scene, camera)
    },
    // 
    // Render Fonctionne
    // 
    render () {
      // time *= 0.001
      const transform = `translateY(${window.scrollY}px)`
      this.renderer.domElement.style.transform = transform

      this.resizeRendererToDisplaySize(this.renderer)

      this.renderer.setScissorTest(false)
      this.renderer.clear(true, true)
      this.renderer.setScissorTest(true)

      this.sceneConfigurations.forEach((sceneInfo) => {
        this.renderScene(sceneInfo)
      })

      requestAnimationFrame(this.render)
    },
    // 
    // 
    // 
    getModels: async function () {
      const getModel = url => { //a function that returns a promise
        const loader = new GLTFLoader()

        if (process.env.NODE_ENV === 'production') {
          url = window.location.origin + this.modelPath + url
        }
        return new Promise((resolve) => {
          loader.load(url, (gltf) => {
            resolve(gltf)
          })
        })
      }

      const goGet = async url => {
        return getModel(url)
      }

      return Promise.all(this.models.map(url => goGet(url)))
    },
    // 
    // INITIALIZE
    // 
    init () {
      const canvas = this.$refs.allStones

      this.renderer = new WebGLRenderer({
        canvas,
        alpha: true,
        antialias: true
      })

      window.addEventListener('mousemove', this.onMouseMove)

      this.$el.appendChild(this.renderer.domElement)
      this.makeScenes()
      this.render()
    }
  },
  // 
  // GATHER ELEMENTS
  // 
  beforeMount () {
    this.gatherCanvases()
  },
  // 
  // WHEN MOUNTING IS DONE
  // 
  async mounted () {
    if (!this.cancelled) {
      const models = await this.getModels()
      this.models = models
      this.init()
    }
  },
}
</script>

<style lang="postcss">
#allStones {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: block;
  z-index: -1;
}
</style>